export default "__VITE_PUBLIC_ASSET__f0ae59b6__"